import { createAsyncThunk } from '@reduxjs/toolkit'
import ReleaseZone from './release-zone-model'
import {
  delete_releaseZone,
  load_releaseZones,
  store_releaseZone,
} from './releaseZone-service'

export const LoadReleaseZonesAsync = createAsyncThunk<any, any>(
  'composer/load/releaseZone',
  async (params: { uid: string }) => {
    return await load_releaseZones(params)
  },
)

export const CreateReleaseZoneAsync = createAsyncThunk<any, any>(
  'composer/create/releaseZone',
  async (params: ReleaseZone) => {
    return await store_releaseZone(params)
  },
)

export const DeleteReleaseZoneAsync = createAsyncThunk<any, any>(
  'composer/delete/releaseZone',
  async (params) => {
    return await delete_releaseZone(params)
  },
)
